import * as app from './app';
import * as commons from './commons';

export default { ...commons, ...app };
